import { navItem } from "aws-amplify";

const options = {
    headers: {}
};

export function setGlobalHeader(header) {
    Object.assign(options.headers, header);
}

export default options;